import {
    ReplyScheduleInThreadListApiV1ReplyScheduleThreadThreadIdGetQueryParams,
    useReplyScheduleInThreadListApiV1ReplyScheduleThreadThreadIdGetInfinite,
} from '../gen/base'

const DEFAULT_LIMIT = 10

export const useInfiniteReplyScheduleInThreadListQuery = (
    threadId: number,
    params?: ReplyScheduleInThreadListApiV1ReplyScheduleThreadThreadIdGetQueryParams,
) => {
    const limit = params?.limit ?? DEFAULT_LIMIT

    return useReplyScheduleInThreadListApiV1ReplyScheduleThreadThreadIdGetInfinite(
        threadId,
        { ...params, limit },
        {},
        {
            query: {
                getNextPageParam: (lastPage, allPages) =>
                    lastPage.offset + limit <= lastPage.total_count
                        ? allPages.length * limit
                        : null,
                initialPageParam: 0,
            },
        },
    )
}
